import React from 'react';
import {TimeTextInput} from './TimeTextInput';

export const TimeWithInfoTextInput = () => {
  return <TimeTextInput infoText="Add asset duration." />;
};
